export default (MaybeRedirect) => MaybeRedirect && MaybeRedirect.props && MaybeRedirect.props.to
